import React from "react";
import { useNavigate } from "react-router-dom";
import argumentImg from "../../Assets/argument.png";
import PropTypes from "prop-types";

const SubscriptionExpiredModal = ({ setSubscriptionError, type }) => {
    const navigate = useNavigate();

    const handleGoBack = () => {
        setSubscriptionError(" ");

        navigate("/");
        sessionStorage.removeItem("access_token");
    };
    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                zIndex: 9999,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            {/* Overlay */}
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0,0,0,0.5)",
                    zIndex: 9998, // lower than modal
                    pointerEvents: "auto",
                }}
            />

            {/* Modal */}
            <div
                style={{
                    position: "relative",
                    width: "500px",
                    maxWidth: "90%",
                    borderRadius: "16px",
                    padding: "30px",
                    background: "linear-gradient(135deg, #339e9efa, #2f8585ff)",
                    color: "#fff",
                    boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
                    zIndex: 10000,
                    textAlign: "center",
                }}
            >
                <div className="flex justify-center mb-4">
                    <div className="bg-white rounded-full p-4">
                        <img
                            src={argumentImg}
                            alt="Subscription Expired"
                            className="w-12 h-12 object-contain drop-shadow-lg"
                        />
                    </div>
                </div>


                <h1 className="subscription-heading blink text-center mb-2">
                    {type === "inactive" ? "Inactive Subscription" : "Subscription Expired!!"}
                </h1>

                <p className="text-center text-gray-100 mb-3">
                    {type === "inactive"
                        ? "Your subscription is inactive due to pending payment or access permissions. Please complete payment or contact support to activate your subscription."
                        : "Your subscription has expired and access is now limited. Please renew to continue enjoying all features and benefits."}
                </p>




                <div style={{ display: "flex", justifyContent: "center" }}>
                    <button
                        onClick={handleGoBack}
                        style={{
                            width: "160px",
                            padding: "12px 0",
                            borderRadius: "8px",
                            fontWeight: "600",
                            backgroundColor: "#fff",
                            color: "#298b8b",
                            cursor: "pointer",
                            border: "none",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                            marginTop: "15px",
                            transition: "background 0.3s ease"
                        }}
                        onMouseOver={(e) => (e.target.style.backgroundColor = "#f5f5f5")}
                        onMouseOut={(e) => (e.target.style.backgroundColor = "#fff")}
                    >
                        Go Back
                    </button>
                </div>
            </div>
        </div>
    );
};

SubscriptionExpiredModal.propTypes = {
    setSubscriptionError: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,

};

export default SubscriptionExpiredModal;
